/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLaptop2Filled: {
  name: 'laptop-2-filled';
  data: string;
} = {
  name: 'laptop-2-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.58 4.047c-.733.14-1.4.821-1.537 1.57C3.014 5.779 3 7.316 3 10.427V15h18v-4.573c0-3.111-.014-4.648-.043-4.81-.141-.768-.806-1.433-1.574-1.574-.307-.056-14.508-.052-14.803.004M2.643 16.069c-.246.087-.496.349-.583.611-.055.164-.065.284-.047.523.033.428.09.64.285 1.057.308.657.78 1.131 1.442 1.444.666.315.137.296 8.26.296s7.594.019 8.26-.296a2.925 2.925 0 0 0 1.444-1.444c.176-.372.296-.865.296-1.217 0-.283-.109-.554-.299-.744-.326-.327.567-.299-9.718-.296-8.192.003-9.182.01-9.34.066"/></svg>`
};
